import React, { Component } from 'react';
import GameListItem from './GameListItem.js';
import './GameList.css';
import $ from 'jquery';
import SortHelper from '../Utils/SortHelper';
import AdBlock from "../External/AdBlock";

class GameList extends Component {

    constructor(props) {
        super(props);
        this.state = {games: []};
        this.games = [];

    }
    componentWillMount(){
        let games = this.games;
        let that = this;

        $.ajax({
            url: 'https://s3-eu-west-1.amazonaws.com/hidat-v3-0.ahrina.com/hidat-v3-0/betting/next',
            type: 'get',
            dataType: 'json'

        }).done(function(data) {
            data.Schedule.Games.forEach(function (game) {
                if (game.StatusCode === '0' && new Date(game.BeginDate) > new Date()) {
                    games.push(game);
                }
            });
            games.sort(SortHelper.dynamicSort("BeginDate"));
            that.setState({games: games});
        });
    }
    returnListItem(item, key) {
        return (
            <GameListItem user={this.props.user} key={ item.GameCode} game={ item } />
        );
    }

    render() {
        return (
            <div className="game-list">
                { this.state.games.map(this.returnListItem.bind(this)) }
                <AdBlock locale={this.props.locale}/>
            </div>
        );
    }
}

export default GameList;


// WEBPACK FOOTER //
// ./src/GameList/GameList.js